export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox'
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio'
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custCode') || '客户名称',
    field: 'custName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_endCustCode') || '客户名称',
    field: 'endCustName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员名字',
    field: 'salesPersonName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_identifyNo') || '识别单号',
    field: 'identifyNo',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderType') || '订单类型',
    field: 'v_orderType',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderSource') || '订单来源',
    field: 'v_orderSource',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderExecuteType') || '执行方式',
    field: 'v_orderExecuteType',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderRemark') || '订单备注说明',
    field: 'orderRemark',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_reviewTime') || '审核时间',
    field: 'reviewTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_order_status') || '订单状态',
    width: 120,
    align: 'center',
    slots: { default: 'status' }
  }
]
